module.exports = __webpack_public_path__ + "static/media/choose-payment-express.f18400d0.svg";